import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const F = "w-full bg-transparent border-b border-ivory/30 py-3 text-ivory placeholder-ivory/40 focus:border-gold focus:outline-none transition-colors";

  return (
    <div className="min-h-screen bg-ink text-ivory flex items-center justify-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm">
        <p className="overline text-gold mb-4">Back-office</p>
        <h1 className="font-serif text-4xl mb-10">Riviera Host Collection</h1>
        <div className="space-y-6">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={F} data-testid="login-email" required />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Mot de passe" className={F} data-testid="login-password" required />
        </div>
        {error && <p className="text-red-400 text-sm mt-4" data-testid="login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="login-submit" className="mt-10 w-full bg-ivory text-ink py-4 overline hover:bg-gold transition-colors disabled:opacity-50">
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
